<template>
  <div class="comBg">
    <!-- <header>我的</header> -->
    <div class="head flex-center">
      <van-uploader class="avatar" :after-read="afterRead">
        <img :src="info.avatar" alt="" class="avatar" />
      </van-uploader>
      <p>{{ info.account }}</p>
    </div>
    <div class="order">
      <van-cell
        title="我的订单"
        is-link
        to="/my/myorder"
        value="查看全部订单"
      />
      <div class="navList flex-around">
        <div
          class="item"
          v-for="(item, index) in navList"
          :key="index"
          @click="goOrder(item.active)"
        >
          <img :src="item.img" alt="" />
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
    <div class="router">
      <div
        class="list flex-between"
        v-for="(item, index) in routeList"
        :key="index"
        @click="goUrl(item.url)"
      >
        <div class="flex-center">
          <img :src="item.img" alt="" />
          <span>{{ item.name }}</span>
        </div>
        <img class="right" src="../../assets/my/more@2x (2).png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      navList: [
        {
          name: "出库",
          img: require("../../assets/my/chuku@2x.png"),
          active: 0,
        },
        {
          name: "支付",
          img: require("../../assets/my/pay@2x.png"),
        },
        {
          name: "待收货",
          img: require("../../assets/my/shouhuo@2x.png"),
        },
        {
          name: "已完成",
          img: require("../../assets/my/daipingjia@2x.png"),
        },
        {
          name: "退款/退货",
          img: require("../../assets/my/tuikuan@2x.png"),
          active: 10,
        },
      ],
      routeList: [
        {
          img: require("../../assets/my/shoucang@2x.png"),
          name: "邀请好友",
          url: "/my/invite",
        },
        // {
        //   img: require("../../assets/my/shoucang@2x.png"),
        //   name: "我的推荐",
        //   url: "/my/group",
        // },
        {
          img: require("../../assets/my/phone.png"),
          name: "绑定手机",
          url: "/my/phone",
        },
        {
          img: require("../../assets/my/lingquan@2x.png"),
          name: "领券中心",
          url: "/my/quan",
        },
        {
          img: require("../../assets/home/youhuiquan@2x.png"),
          name: "我的优惠券",
          url: "/my/myQuan",
        },
        {
          img: require("../../assets/my/shoucang@2x.png"),
          name: "我的收藏",
          url: "/my/collect",
        },
        {
          img: require("../../assets/my/add@2x.png"),
          name: "我的地址",
          url: "/my/address",
        },
        {
          img: require("../../assets/my/liulan@2x.png"),
          name: "浏览记录",
          url: "/my/browseRecords",
        },
        {
          img: require("../../assets/my/aboutus@2x.png"),
          name: "关于我们",
          url: "/my/aboutUs",
        },
        {
          img: require("../../assets/my/jilu@2x.png"),
          name: "我的反馈记录",
          url: "/my/feedback",
        },
        {
          img: require("../../assets/my/fankui@2x.png"),
          name: "问题反馈",
          url: "/my/feedback/form",
        },
      ],
      info: {},
    };
  },
  pass: true,
  computed: {},
  methods: {
    afterRead(file) {
      this.$func
        .uploadImage(file, true)
        .then((res) => {
          return this.$post({
            module: "User",
            interface: "1001",
            data: {
              avatar: res.data,
            },
          });
        })
        .then(() => {
          this.$toast("头像设置成功");
          this.$func.sleep().then(this.getInfo);
        })
        .catch((err) => {
          this.$toast(err.message || "失败，请重试");
        });
    },
    goOrder(active) {
      if (active == 10) {
        this.$router.push("/my/myorder");
      }
    },
    goUrl(url) {
      this.$router.push(url);
    },
    getInfo() {
      this.$post({
        module: "User",
        interface: "1000",
        data: {},
      }).then((res) => {
        // console.log(res);
		localStorage.setItem('mobile',res.mobile)
        this.info = res;
      });
    },
  },
  destroyed(){
  	  console.log(1)
  	// this.closeLoad != this.closeLoad
  },
  created() {
    this.getInfo();
  },
};
</script>

<style lang='less' scoped>
header {
  text-align: center;
  line-height: 40px;
  position: sticky;
  top: 0;
  background-color: #fbfbfb;
}

.comBg {
  padding-bottom: 14px;
}

.head {
  height: 90px;

  .avatar {
    width: 56px;
    height: 56px;
    border-radius: 50%;
  }
  p {
    font-size: 18px;
    margin-left: 15px;
  }
}
.order {
  height: 120px;
  background: #ffffff;
  box-shadow: 0px 2px 16px 0px rgba(65, 66, 69, 0.1);
  border-radius: 8px;
}
.navList {
  .item {
    text-align: center;
    margin-top: 10px;
    img {
      width: 28px;
      height: 28px;
    }
    p {
      font-size: 12px;
      color: #666666;
    }
  }
}
.router {
  background: #ffffff;
  box-shadow: 0px 2px 16px 0px rgba(65, 66, 69, 0.1);
  border-radius: 8px;
  padding: 0 14px;
  margin-top: 18px;
  .flex-center {
    height: 46px;
    img {
      width: 30px;
      height: 30px;
      margin-right: 14px;
    }
  }
  .right {
    width: 18px;
    height: 18px;
  }
}
</style>
